import { useAudioStore } from 'context/AudioContext/AudioContext'

interface Props {
    onlyDuration?: boolean
}

export const AudioDuration = ({ onlyDuration = false }: Props) => {
    const state = useAudioStore()
    const { duration, currentTime } = state

    const formatTime = (time: number, separator = ':'): string => {
        const minutes = Math.floor(time / 60)
        const seconds = Math.floor(time % 60)

        const formatedTime = `${minutes}${separator}${
            seconds < 10 ? '0' : ''
        }${seconds}`

        return formatedTime
    }

    return (
        <p>
            {onlyDuration
                ? formatTime(duration, ':')
                : `${formatTime(currentTime, ':')} / ${formatTime(
                      duration,
                      ':'
                  )}`}
        </p>
    )
}
